export const GUEST_DEMO_BUTTON_LABEL = 'PLAY DEMO FOR FREE. NO SIGNUP REQUIRED';

export const RIDDLED_IN_DEMO_NOTE =
  'Riddled-In demo: Demo riddle is pre-generated. Real mode is infinite + daily rewards.';

export const EARTH_DEMO_NOTE =
  'Zoomed In Earth demo: 3 fixed Impossible rounds. Real mode gives fresh Street View rounds + daily rewards.';
